import React from 'react';
import {useMutation, useQuery} from '@apollo/client';
import {updateCreate, updateDelete} from '../../utils/mutation';
import Query from '../../components/Query';
import Validation from '../../components/Validation';
import FriendAcceptedList from '../Friend/AcceptedList';
import {QUERY_THEME_LIST} from '../Theme/graphql';
import {MUTATION_INTEREST_DELETE, MUTATION_INTEREST_SAVE, QUERY_INTEREST_LIST} from '../Interest/graphql';
import {MUTATION_TALK_SAVE} from './graphql';
import {Link, useRouteMatch} from 'react-router-dom';

const TalkSave = () => {
  const match = useRouteMatch();

  const themesQuery = useQuery(QUERY_THEME_LIST);
  const {interestList} = useQuery(QUERY_INTEREST_LIST).data || {interestList: []};

  const [interestSave] = useMutation(MUTATION_INTEREST_SAVE, {
    update: (cache, response) => updateCreate(cache, response, {query: QUERY_INTEREST_LIST}),
  });

  const [interestDelete] = useMutation(MUTATION_INTEREST_DELETE, {
    update: (cache, response) => updateDelete(cache, response, {query: QUERY_INTEREST_LIST}),
  });

  const [save, saveResp] = useMutation(MUTATION_TALK_SAVE);

  return (
    <div className="py-4">
      <FriendAcceptedList />
      <div className="mt-4">
        <div className="row align-items-center mb-4">
          <div className="fw-bold font-4 col-12 col-lg">Темы для беседы: {interestList.length} / 5</div>
          <div className="col-12 col-lg-auto">
            <Validation data={saveResp.data} field="non_field_errors" cls="me-3" />
          </div>
          <button
            onClick={() => save({variables: {input: {client2: null}}})}
            // disabled={!isActive(user)}
            className="col-12 col-lg-auto mt-2 mt-lg-0 btn btn-primary"
          >
            Начать случайную беседу {saveResp.loading ? '...' : ''}
          </button>
        </div>
        <div className="row gx-lg-4 gy-4">
          {Query(themesQuery) ||
            themesQuery.data.themeList.map(item => {
              const interested = interestList.find(x => x.themeId === item.id);

              return (
                <div key={item.id} className="col-12 col-md-6 col-lg-3">
                  <div className="border rounded overflow-hidden">
                    <div
                      className="ratio ratio-4x3"
                      style={{
                        background: `url("${item.image && item.image.path}") center center no-repeat`,
                        backgroundSize: 'cover',
                        // filter: 'grayscale(100%)',
                      }}
                    />
                    <div className="bg-white rounded p-2">
                      <div className="mb-1">{item.name}</div>
                      <div className="text-muted font-2">{item.topicsCount} вопросов</div>
                      <div className="row align-items-center justify-content-end">
                        <div className="col-auto">
                          <Link to={`themes/${item.id}`} className="font-2 me-3">
                            Открыть
                          </Link>
                        </div>
                        <div className="col-auto">
                          <button
                            onClick={() =>
                              interested
                                ? interestDelete({variables: {input: {id: interested.id}}})
                                : interestSave({variables: {input: {theme: item.id}}})
                            }
                            className={`btn btn-sm ml-3 btn-${interested ? 'primary' : 'light'}`}
                          >
                            {interested ? 'Удалить' : 'Добавить'}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
};

export default TalkSave;
